import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-white py-20" aria-labelledby="faq-title" data-id="element-64" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-65" data-mp="1cf9nsi0k0hkr">
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-navy-900 md:text-4xl" data-id="element-66" data-mp="1ccdp2rgvtov9">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 space-y-3" data-id="element-67" data-mp="2546zu3e69i52">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-lg border bg-canvas transition-colors duration-200 ease-out ${isOpen ? 'border-leaf-500' : 'border-navy-100'}`} data-id="element-68" data-mp="1v580xcj7l0v9" data-mpi={index}>
                <h3 data-id="element-69" data-mp="jp1d1b8ckzg7">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-sans font-bold text-navy-900 focus:outline-none focus-visible:ring-4 focus-visible:ring-sun-400/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-70" data-mp="johsrnv85yz0">
                    <span data-id="element-71" data-mp="1fmst4kdmplqw">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-leaf-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-72" data-mp="11wpas4hvec6q" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-73" data-mp="wy5p8576v2ew">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-74" data-mp="wvt5pnls8jzq">
                      <p className="border-t border-navy-100 px-5 py-4 leading-relaxed text-navy-700 sm:px-6" data-id="element-75" data-mp="2kvx0mmnvvz71">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}